import { BrickContext, ActionBrick, registerBrick, File as OFile, Transaction, CloudObject, ErrorFlow } from 'olympe';
import {getLogger} from "@olympeio/core";

export default class ConvertCanvasToImage extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} canvasRef
     * @param {string} fileName
     * @param {function()} forwardEvent
     * @param {function(File)} setFile
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [canvasRef, fileName], [forwardEvent, setFile, setErrorFlow]) {

        if (canvasRef) {
            const imgURL = canvasRef.toDataURL('image/png');

            const transaction = new Transaction(false);
            const file = transaction.create(OFile);
            OFile.setURLContent(
                transaction,
                file,
                fileName ?? 'new image.png',
                imgURL,
                'image/png'
            );
            transaction.execute()
                .then(() => {
                    setFile(CloudObject.get(file));
                    forwardEvent();
                }).catch((message) => {
                setErrorFlow(ErrorFlow.create(message, 1));
            });
        } else {
            getLogger('CanvasToImage').warn('No canvas provided; Ignoring conversion')
        }
    }
}

registerBrick('0192c73df37c559cbc51', ConvertCanvasToImage);
